import React from "react";
import { FaBalanceScale } from "react-icons/fa";

import ProductCard from "./ProductCard";
import {
  stripMatchPrefix,
} from "../../utils/recommendationBlurbUtils";
import { SIMILAR_PRODUCTS_SOURCES } from "../../utils/resolveSimilarProducts";
import styles from "../../styles/pages/product/ProductDetailsPage.module.css";

const getSubtitle = (source, contextSummary) => {
  if (source === SIMILAR_PRODUCTS_SOURCES.AI_SESSION) {
    return contextSummary
      ? `Based on your AI search: ${contextSummary}`
      : "Based on your AI search";
  }
  if (source === SIMILAR_PRODUCTS_SOURCES.INTENT_ENGINE) {
    return "Based on your preferences and specs near this product";
  }
  return "Other products in this category";
};

const formatSecondaryLine = (item) => {
  if (item.scoreSource === SIMILAR_PRODUCTS_SOURCES.AI_SESSION) {
    return item.matchExplanation
      ? item.matchExplanation.slice(0, 120) +
          (item.matchExplanation.length > 120 ? "…" : "")
      : null;
  }

  if (item.comparisonLabel) {
    return stripMatchPrefix(item.comparisonLabel);
  }

  return null;
};

const ProductSimilarProductsSection = ({
  items = [],
  source,
  contextSummary,
  loading = false,
  showCount,
  selectedProductsCount,
  categoryId,
  product,
  onCompareSelected,
  onViewFullComparison,
}) => {
  if (loading) {
    return (
      <div className={styles.similarProducts}>
        <div className={styles.similarProductsHeader}>
          <h3>Similar Products</h3>
          <p className={styles.similarProductsSubtitle}>Loading similar products…</p>
        </div>
      </div>
    );
  }

  if (!items.length) return null;

  return (
    <div className={styles.similarProducts}>
      <div className={styles.similarProductsHeader}>
        <h3>Similar Products</h3>
        <p className={styles.similarProductsSubtitle}>
          {getSubtitle(source, contextSummary)}
        </p>
        {selectedProductsCount >= 2 && (
          <button
            className={styles.compareSelectedBtn}
            onClick={onCompareSelected}
            type="button"
          >
            <FaBalanceScale /> Compare {selectedProductsCount} Products
          </button>
        )}
      </div>

      {selectedProductsCount > 0 && selectedProductsCount < 2 && (
        <p className={styles.compareHint}>
          Select at least 2 products to compare
        </p>
      )}

      <div className={styles.productGrid}>
        {items.slice(0, showCount).map((item) => {
          const p = item.product;
          const productCategoryId =
            p.category?._id ||
            p.category ||
            categoryId ||
            product?.category?._id ||
            product?.category;

          const cardProduct = item.showMatchScore
            ? p
            : { ...p, matchScore: null, aiRanked: false };

          const secondaryLine = formatSecondaryLine(item);

          return (
            <div key={p._id} className={styles.similarProductCardWrap}>
              <ProductCard
                product={cardProduct}
                categoryId={productCategoryId}
                rank={item.rank}
              />
              {secondaryLine && (
                <p className={styles.similarProductCaption}>{secondaryLine}</p>
              )}
            </div>
          );
        })}
      </div>

      {onViewFullComparison && (
        <button
          className={styles.viewFullComparisonBtn}
          onClick={onViewFullComparison}
          type="button"
        >
          View Full Comparison →
        </button>
      )}
    </div>
  );
};

export default ProductSimilarProductsSection;
